import React from 'react';
import PropTypes from 'prop-types';
import ErrorText from 'components/snippets/errorText';
import Lang from 'libraries/Lang';

const VacationTravellers = (props) => {
    const {
        visible,
        travellers,
        errors,
        onVisibilityChange,
        onChange,
    } = props;

    const changeRooms = (event) => {
        const newTravellers = Object.assign({}, travellers);
        newTravellers.rooms = event.target.value;

        onChange(newTravellers);
    };

    const changeAdults = (event) => {
        const newTravellers = Object.assign({}, travellers);
        newTravellers.adults = event.target.value;

        onChange(newTravellers);
    };

    const changeChildren = (event) => {
        const newTravellers = Object.assign({}, travellers);
        const numChildren = parseInt(event.target.value, 10);
        const { ages } = newTravellers;

        if (numChildren > ages.length) {
            for (let i = ages.length; i < numChildren; i++) {
                ages.push('');
            }
        } else {
            newTravellers.ages = ages.slice(0, numChildren);
        }

        newTravellers.children = numChildren;
        onChange(newTravellers);
    };

    const changeAge = (event, index) => {
        const newTravellers = Object.assign({}, travellers);
        const { ages } = newTravellers;

        ages[index] = event.target.value;

        onChange(newTravellers);
    };

    const toggleTravellers = () => {
        onVisibilityChange(!visible);
    };

    const handleTabKey = (e) => {
        if(e.key == 'Tab') {
            onVisibilityChange(!visible);
        }
    }

    const numTravellers = parseInt(travellers.adults, 10) + travellers.children;

    return (
        <div className="htl_popover btn-unstyled-container">

            <label className="text-label">{Lang.trans("engine.adults")} &amp; {Lang.trans("engine.children")}</label>
            <button type="button" className="btn-unstyled w-100 text-left" onClick={toggleTravellers} onKeyUp={handleTabKey}>

                {/* {travellers.rooms} room(s), {numTravellers} guests */}
                {travellers.rooms} {Lang.trans('engine.room')}(s), {numTravellers} {Lang.trans('engine.guests')}
                <svg className="icon icon-btn" aria-hidden="true" xmlnsXlink="http://www.w3.org/1999/xlink">
                    <use xlinkHref="/img/icons/icon-defs.svg#icon-chevron-down" />
                </svg>
            </button>
            <div className={`popover guests-popover ${visible ? '' : 'hidden'}`}>
                {/* <button type="button" className="popover-close" aria-label="Close Travellers" onClick={toggleTravellers} /> */}
                <div className="custom-form-element">
                    <div className="">
                        <div className="room-title">{Lang.trans('engine.select')} {Lang.trans('engine.rooms')}</div>
                        <div className="row gutter-10">
                            <div className="col-12 select-container">
                                <label htmlFor="vac_rooms">Rooms</label>
                                <div className="element-container input-chevron-down">
                                    <select id="vac_rooms" className="select-custom" value={travellers.rooms} onChange={changeRooms}>
                                        <option value="1">1</option>
                                        <option value="2">2</option>
                                        <option value="3">3</option>
                                        <option value="4">4</option>
                                        <option value="5">5</option>
                                        <option value="6">6</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="room-title">{`${Lang.trans('engine.adults')} ${Lang.trans('engine.and')} ${Lang.trans('engine.children')}`}</div>
                        {errors && (
                            <div className="error-container w-100 mb-2">
                                {Object.keys(errors).map((error) => (
                                    <ErrorText error={{ message: errors[error], id: error }} />
                                ))}
                            </div>
                        )}
                        <div className="row gutter-10">
                            <div className="col-6 select-container">
                                <label htmlFor="vac_adults">{Lang.trans('engine.adults')}</label>
                                <div className="element-container input-chevron-down">
                                    <select id="vac_adults" className="select-custom" value={travellers.adults} onChange={changeAdults}>
                                        <option value="1">1</option>
                                        <option value="2">2</option>
                                        <option value="3">3</option>
                                        <option value="4">4</option>
                                        <option value="5">5</option>
                                        <option value="6">6</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-6 select-container">
                                <label htmlFor="vac_children">{Lang.trans('engine.children')}</label>
                                <div className="element-container input-chevron-down">
                                    <select id="vac_children" className="select-custom" value={travellers.children} onChange={changeChildren} onKeyDown={(travellers.children == 0) ? handleTabKey : null}>
                                        <option value="0">0</option>
                                        <option value="1">1</option>
                                        <option value="2">2</option>
                                        <option value="3">3</option>
                                        <option value="4">4</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        {travellers.ages.length > 0 && (
                            <div className="child-age">
                                <span htmlFor="">{Lang.trans('engine.child_age_upon_return')}</span>
                                <div className="row gutter-10">
                                    {travellers.ages.map((age, index) => (
                                        <div className="col-6 select-container" key={index}>
                                            <label className="label-secondary" htmlFor={`vac_age_${index}`}>{Lang.trans('engine.child')} {index + 1}</label>
                                            <div className="element-container input-chevron-down">
                                                <select id={`vac_age_${index}`} className="select-custom" value={age} onChange={(event) => { changeAge(event, index); }} onKeyDown={((travellers.ages.length - 1) == index) ? handleTabKey : null}>
                                                    <option value="">-- </option>
                                                    <option value="IN">INF</option>
                                                    <option value="2">2 </option>
                                                    <option value="3">3 </option>
                                                    <option value="4">4 </option>
                                                    <option value="5">5 </option>
                                                    <option value="6">6 </option>
                                                    <option value="7">7 </option>
                                                    <option value="8">8 </option>
                                                    <option value="9">9 </option>
                                                    <option value="10">10 </option>
                                                    <option value="11">11 </option>
                                                    <option value="12">12 </option>
                                                    <option value="13">13 </option>
                                                    <option value="14">14 </option>
                                                    <option value="15">15 </option>
                                                    <option value="16">16 </option>
                                                    <option value="17">17 </option>
                                                </select>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

VacationTravellers.propTypes = {
    errors: PropTypes.instanceOf(Object),
    travellers: PropTypes.instanceOf(Object).isRequired,
    onChange: PropTypes.func.isRequired,
    visible: PropTypes.bool.isRequired,
    onVisibilityChange: PropTypes.func.isRequired,
};

VacationTravellers.defaultProps = {
    errors: null,
};

export default VacationTravellers;
